import axiosInstance from "./axiosConfig";

const isUnauthorizedError = (error) => error?.response?.status === 401;

class AuthService {
  constructor() {
    this.currentUser = null;
    this.pendingUserRequest = null;
  }

  async login(email, password) {
    try {
      await axiosInstance.post("auth/web/login", { email, password });
      await this.fetchAndStoreUserData();
      return true;
    } catch (error) {
      console.error("Erro no login:", error.response?.data || error.message);
      throw error;
    }
  }

  async logout() {
    this.clearSessionData();

    try {
      await axiosInstance.post("auth/web/logout");
    } catch (error) {
      console.error("Erro ao finalizar sessão:", error.response?.data || error.message);
    }
  }

  getToken() {
    return null;
  }

  async isAuthenticated() {
    if (this.currentUser) {
      return true;
    }

    try {
      await this.fetchAndStoreUserData();
      return true;
    } catch {
      this.clearSessionData();
      return false;
    }
  }

  async refreshToken() {
    this.clearSessionData();
    return false;
  }

  async fetchAndStoreUserData() {
    if (this.pendingUserRequest) {
      return this.pendingUserRequest;
    }

    try {
      this.pendingUserRequest = axiosInstance.get("users/profile");

      const response = await this.pendingUserRequest;
      this.currentUser = response.data.data[0] || null;

      return this.currentUser;
    } catch (error) {
      if (!isUnauthorizedError(error)) {
        console.error("Erro ao buscar dados do usuário:", error.response?.data || error.message);
      }
      this.currentUser = null;
      throw error;
    } finally {
      this.pendingUserRequest = null;
    }
  }

  getCurrentUser() {
    return this.currentUser;
  }

  clearSessionData() {
    this.currentUser = null;
    this.pendingUserRequest = null;
  }
}

const authService = new AuthService();

export default authService;